import * as React from "react";
import { Button, Card, CardContent, CardMedia, Typography } from "@mui/material";
import WifiAnimationLogo from "../components/WifiAnimationLogo/WifiAnimationLogo";
import { useNavigate } from "react-router-dom";

type ReloadVisibility = boolean;

const SaveConnection = () => {
  const [isReloadVisible, setReloadVisible] = React.useState<ReloadVisibility>(false);

  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/");
  };

  React.useEffect(() => {
    const timeoutId = setTimeout(() => {
      setReloadVisible(true);
    }, 3500);

    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <div className="SaveConnectionPage">
      <Card className="SaveConnectionPage__card">
        <CardContent>
          <CardMedia src="/" className="SaveConnectionPage__image" />
          <div className="SaveConnectionPage__info">
            <WifiAnimationLogo />
            <Typography color="textSecondary" gutterBottom>
              Securing your
              <br />
              connection
            </Typography>
            {isReloadVisible && (
              <Button
                variant="outlined"
                size="small"
                color="primary"
                sx={{ marginTop: "20px" }}
                onClick={handleClick}
              >
                Reload App
              </Button>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default SaveConnection;
